// extracted by mini-css-extract-plugin
export default {"wrapper":"portfolioAutoTradeDetail_wrapper__+A7nY","chartTabs":"portfolioAutoTradeDetail_chartTabs__3K2Gt","tabs":"portfolioAutoTradeDetail_tabs__RHB73"};